import { Rss, Smartphone } from 'lucide-react';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';

export default function FeedPage() {
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('post_id');

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#9B1421]/20 flex items-center justify-center">
              <Rss size={20} className="text-text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-[#EBFFEE]">Feed</h1>
              <p className="text-sm text-[#A9A3A3]">Community updates and announcements</p>
            </div>
          </div>
        </div>

        {/* Feed Content */}
        <Card className="bg-[#221F1F] border-[#504A4A]">
          <CardHeader>
            <CardTitle className="text-[#EBFFEE] flex items-center gap-2">
              <Rss className="w-5 h-5 text-rollops-accent" />
              Community Feed
            </CardTitle>
          </CardHeader>
          <CardContent className="!p-6">
            {postId ? (
              <div className="text-center py-12">
                <div className="mb-6">
                  <Smartphone className="w-16 h-16 text-rollops-accent mx-auto mb-4" />
                </div>
                <h3 className="text-xl font-semibold text-[#EBFFEE] mb-3">
                  View Post on Mobile
                </h3>
                <p className="text-white/80 mb-2">
                  The feed feature is currently available on mobile.
                </p>
                <p className="text-sm text-white/60 mb-6">
                  Check the RollOps mobile app to view this post and interact with comments.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <Button
                    onClick={() => {
                      // Clear the post_id param
                      const newParams = new URLSearchParams(searchParams);
                      newParams.delete('post_id');
                      window.history.replaceState({}, '', `${window.location.pathname}${newParams.toString() ? `?${newParams.toString()}` : ''}`);
                    }}
                    className="bg-[#363232] hover:bg-[#504A4A] text-[#EBFFEE]"
                  >
                    Dismiss
                  </Button>
                </div>
              </div>
            ) : (
              <div className="text-center py-12">
                <p className="text-white/80 mb-4">
                  Your gym&apos;s social feed will appear here soon.
                </p>
                <p className="text-sm text-white/80">
                  Share updates, celebrate achievements, and keep your community engaged.
                </p>
                <div className="mt-6 pt-6 border-t border-[#504A4A]">
                  <p className="text-sm text-white/60 mb-2">
                    💡 <strong>Tip:</strong> The feed is currently available on mobile.
                  </p>
                  <p className="text-xs text-white/50">
                    Check the RollOps mobile app to view posts, comments, and reactions.
                  </p>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
  );
}
